import React, { useState } from "react";
import { Link } from "react-router-dom";
import ErrorText from "../../../core/components/error-text";
import { Form } from "react-bootstrap";

const StepFirst = ({ formik }: any) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [confirmPasswordVisible, setConfirmPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible((prev) => !prev);
  };

  const toggleConfirmPasswordVisibility = () => {
    setConfirmPasswordVisible((prev) => !prev);
  };

  return (
    <>
      <div className="main-wrapper authendication-pages register-page">
        {/* Page Content */}
        <div className="content">
          <div className="container wrapper no-padding register-screen">
            <div className="row no-margin align-items-stretch">
              <div className="col-12 col-sm-12 col-lg-8 no-padding d-flex">
                <div className="banner-bg banner-bg-1 login">
                  <div className="row h100">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <div className="row h-100">
                        <div className="col-md-12 h-100">
                          <img
                            src="/assets/img/authImg.jpg"
                            className="object-fit-cover img-fluid h-100 w-100"
                            alt="authImg"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-12 col-sm-12 col-md-12 col-lg-4 no-padding d-flex">
                <div className="dull-pg shadow-card w-100 create-account-area">
                  <div className="row no-margin vph-90 d-flex align-items-center justify-content-center ">
                    <div className="col-sm-10 col-md-10 col-lg-10 mx-auto mb-2">
                      <div className="shadow-card-inner ">
                        <h2 className="text-center">Create Account</h2>
                        <p className="text-center">
                          Join now to connect with fans, access exclusive
                          content, and stay updated!
                        </p>
                        <div className="tab-content" id="myTabContent">
                          <div
                            className="tab-pane fade show active"
                            id="user"
                            role="tabpanel"
                            aria-labelledby="user-tab"
                          >
                            {/* Register Form */}
                            <form
                              autoComplete="off"
                              onSubmit={formik.handleSubmit}
                            >
                              <div className="form-group">
                                <label>Name</label>
                                <div className="group-img iconLeft  position-relative">
                                  <input
                                    name="name"
                                    id="name"
                                    type="text"
                                    maxLength={64}
                                    className="form-control commonInput"
                                    placeholder="Your name"
                                    onChange={(ev: any) => {
                                      formik.setFieldValue(
                                        "name",
                                        ev.target.value.trim()
                                      );
                                    }}
                                  />
                                </div>
                                <div className="text-start">
                                  <ErrorText
                                    show={
                                      formik.errors.name && formik.touched.name
                                    }
                                    message={formik.errors?.name}
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label>Email</label>
                                <div className="group-img iconLeft  position-relative">
                                  <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    maxLength={64}
                                    className="form-control commonInput"
                                    placeholder="Enter your email"
                                    onChange={(ev: any) => {
                                      formik.setFieldValue(
                                        "email",
                                        ev.target.value
                                      );
                                    }}
                                  />
                                </div>
                                <div className="text-start">
                                  <ErrorText
                                    show={
                                      formik.errors.email &&
                                      formik.touched.email
                                    }
                                    message={formik.errors?.email}
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label>Phone Number</label>
                                <div className="group-img iconLeft position-relative">
                                  <span
                                    className="position-absolute top-50 start-0 translate-middle-y ps-3 text-muted user-select-none"
                                    style={{ pointerEvents: "none" }}
                                  >
                                    +1
                                  </span>
                                  <input
                                    name="phone"
                                    id="phone"
                                    type="tel"
                                    inputMode="numeric"
                                    maxLength={10}
                                    className="form-control commonInput ps-5"
                                    placeholder="Enter your phone number"
                                    value={formik.values.phone}
                                    onBlur={formik.handleBlur}
                                    onChange={(ev: any) => {
                                      const raw = ev.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 10);
                                      formik.setFieldValue("phone", raw);
                                    }}
                                    aria-label="Phone number"
                                  />
                                </div>
                                <div className="text-start">
                                  <ErrorText
                                    show={
                                      formik.errors.phone &&
                                      formik.touched.phone
                                    }
                                    message={formik.errors?.phone}
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label>Password</label>
                                <div className="group-img iconLeft  position-relative">
                                  <div className="pass-group group-img">
                                    <i
                                      className={`toggle-password ${passwordVisible ? "feather-eye" : "feather-eye-off"}`}
                                      onClick={togglePasswordVisibility}
                                    />
                                    <input
                                      name="password"
                                      id="password"
                                      type={
                                        passwordVisible ? "text" : "password"
                                      }
                                      maxLength={64}
                                      className="form-control commonInput"
                                      placeholder="Enter  your password"
                                      onChange={(ev: any) => {
                                        formik.setFieldValue(
                                          "password",
                                          ev.target.value
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="text-start">
                                  <ErrorText
                                    show={
                                      formik.errors.password &&
                                      formik.touched.password
                                    }
                                    message={formik.errors?.password}
                                  />
                                </div>
                              </div>

                              <div className="form-group">
                                <label>Confirm Password</label>
                                <div className="group-img iconLeft  position-relative">
                                  <div className="pass-group group-img">
                                    <i
                                      className={`toggle-password ${confirmPasswordVisible ? "feather-eye" : "feather-eye-off"}`}
                                      onClick={toggleConfirmPasswordVisibility}
                                    />
                                    <input
                                      name="confirmPassword"
                                      id="confirmPassword"
                                      type={
                                        confirmPasswordVisible
                                          ? "text"
                                          : "password"
                                      }
                                      maxLength={64}
                                      className="form-control commonInput"
                                      placeholder="Confirm your password"
                                      onChange={(ev: any) => {
                                        formik.setFieldValue(
                                          "confirmPassword",
                                          ev.target.value
                                        );
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="text-start">
                                  <ErrorText
                                    show={
                                      formik.errors.confirmPassword &&
                                      formik.touched.confirmPassword
                                    }
                                    message={formik.errors?.confirmPassword}
                                  />
                                </div>
                              </div>

                              <div className="form-check user-login-check d-flex align-items-start w-100">
                                <Form.Check
                                  id="termsConditions"
                                  name="termsConditions"
                                  checked={formik.values.termsConditions}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  aria-label="Terms and Conditions"
                                  className="mt-1 me-2 flex-shrink-0"
                                />

                                <label
                                  className="form-check-label"
                                  htmlFor="termsConditions"
                                  style={{
                                    fontSize: "13px",
                                    lineHeight: "1.4",
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    overflowWrap: "break-word",
                                    width: "100%",
                                  }}
                                >
                                  By providing your phone number, you agree to receive SMS verification
                                  and authentication messages from TracNest. Message and data rates may
                                  apply. Reply STOP to opt out. View our{" "}
                                  <Link
                                    to={"https://tracnest.com/terms-conditions"}
                                    target="_blank"
                                  >
                                    Terms & Conditions
                                  </Link>{" "}
                                  and{" "}
                                  <Link
                                    to={"https://tracnest.com/privacy-policy"}
                                    target="_blank"
                                  >
                                    Privacy Policy
                                  </Link>
                                  .
                                </label>
                              </div>
                              <div className="text-start">
                                <ErrorText
                                  show={
                                    formik.errors.termsConditions &&
                                    formik.touched.termsConditions
                                  }
                                  message={formik.errors.termsConditions}
                                />
                              </div>

                              <button
                                // disabled={error? true: false}
                                className="btn primaryButton  btn-primary d-inline-flex justify-content-center align-items-center w-100 btn-block"
                                type="submit"
                              >
                                Continue
                              </button>
                            </form>
                            {/* /Register Form */}
                          </div>
                        </div>
                      </div>
                      <div className="bottom-text text-center">
                        <p>
                          {" "}
                          Already have an account?{" "}
                          <Link to={"/auth/login"} className="text-underline">
                            Sign in!
                          </Link>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /Page Content */}
      </div>
    </>
  );
};

export default StepFirst;
